import di from 'di';

import { ApolloLink } from '@apollo/client';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import { createApolloProvider } from '@vue/apollo-option'

import StorageKey from '@/js/enum/StorageKey';

export default function(app){

    const config = di.get('config');

    // Apollo
    const httpLink = createHttpLink({
        uri: config.apiUrl + '/graphql',
    });

    const authLink = new ApolloLink((operation, forward) => {

        const code = window.localStorage.getItem(StorageKey.SCREEN_CODE)

        if(code) {

            operation.setContext({
                headers: {
                    Authorization: `ScreenCode ${code}`
                }
            });
        }

        return forward(operation);
    });

    const link = authLink.concat(httpLink);
    const cache = new InMemoryCache();

    const apolloClient = new ApolloClient({
        link, cache
    });

    di.set('apollo', apolloClient);


    // VueApollo
    const vueApollo = createApolloProvider({
        defaultClient: apolloClient
    })

    app.use(vueApollo);
}